<template>
<v-container>
   <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
    </v-app-bar>
  </nav>
  
  <template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left" style="color:white;">
            DB Board
          </th>
           <th class="text-left" style="color:white;">
            Phase Label
          </th>
          <th class="text-left" style="color:white;">
            Single Phase Sensor Label
          </th>
          <th class="text-left" style="color:white;">
            Single Phase Sensor S/N
          </th>
 
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in singlePhase"
          :key="item.rybConsole"
        >
          <td>{{ item.boardName }}</td>
          <td>R</td>
          <td>{{ item.rybConsoleR }}</td>
          <td>{{ item.rybSnR }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in singlePhase"
          :key="item.rybConsole"
        >
          <td>{{ item.boardName }}</td>
          <td>Y</td>
          <td>{{ item.rybConsoleY }}</td>
          <td>{{ item.rybSnY }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in singlePhase"
          :key="item.rybConsole"
        >
          <td>{{ item.boardName }}</td>
          <td>B</td>
          <td>{{ item.rybConsoleB }}</td>
          <td>{{ item.rybSnB }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  <!-- <p>{{loadTypeA}}</p> -->
   
</template>
<v-btn fixed dark fab bottom right color="green" :to="{ name: 'Single Phase Edit', params: { id: this.$route.params.id } }">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
</v-container>
</template>

<script>
import axios from "axios";

  export default {
    data () {
      return {
        items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Settings',
          disabled: true,
          href: '',
        },
        {
          text: 'Single Phase',
          disabled: false,
          href: '/single-phase',
        },
        {
          text: 'Details',
          disabled: true,
          href: '',
        },
      ],
        singlePhase: []
      }
    },
    mounted() {
    this.loadsSinglePhase();
  },
    methods:{
      loadsSinglePhase: async function(){
      let apiURL = process.env.VUE_APP_API + "/api/single-phase/" + this.$route.params.id;
      axios.get(apiURL).then(res => {
      this.singlePhase = res.data;
      }).catch(error => {
      console.log(error)
      });
},
    }
  }
</script>

<style scoped>
table, th, td {
  border: 2px groove;
}
th{
  background-color: rgb(35, 35, 35);
}
</style>